import { render, staticRenderFns } from "./SMSCampaignInfoRoute.vue?vue&type=template&id=05f72d34&scoped=true&"
import script from "./SMSCampaignInfoRoute.vue?vue&type=script&lang=js&"
export * from "./SMSCampaignInfoRoute.vue?vue&type=script&lang=js&"
import style0 from "./SMSCampaignInfoRoute.vue?vue&type=style&index=0&id=05f72d34&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f72d34",
  null
  
)

export default component.exports